// Footer.js
import React from 'react';
import './Footer.css'; // Assuming you have a separate CSS file for the footer

const Footer = () => {
    return (
        <footer className="footer" >
            <p>© 2025 UNDP Haiti Staff Management System</p>
        </footer>
    );
};

export default Footer;
